<template>
  <div class="ess-element-wrap">
    <div class="ess-line" :class="get_line_class(gatewayMeter.data ? gatewayMeter.data.p_total : null)"></div>
    <div class="ess-element">
      <div class="ess-element__header meter">
        <img src="@/assets/images/topo/电表.png" height="24" alt="" srcset="">
        <span class="ess-element__name" :title="gatewayMeter.uuid">{{ gatewayMeter.meterName || '--' }}</span>
      </div>
      <div class="ess-element__body">
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/总有功功率')"><abbr>{{$str.getKey('数据可视化/功率')}}：</abbr><b>{{ gatewayMeter.data ?
              gatewayMeter.data.p_total : '--'
          }}</b>kW</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/AB线电压')"> <abbr>{{$str.getKey('数据可视化/电压')}}：</abbr><b>{{ gatewayMeter.data ?
              gatewayMeter.data.u_a : '--'
          }}</b>V</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/A相电流')"> <abbr>{{$str.getKey('数据可视化/电流')}}：</abbr><b>{{ gatewayMeter.data ?
              gatewayMeter.data.i_a : '--'
          }}</b>A</span>
        </div>
      </div>
    </div>

    <div class="ess-line" :class="get_line_class(gatewayMeter.data ? gatewayMeter.data.p_total : null)"></div>
  </div>

</template>

<script>

const $str = window.$str

export default {
  setup() {
    return {
      $str
    }
  },
  props: {
    gatewayMeter: {
      type: Object,
      default: function () {
        return {
          data: {}
        }
      }
    }
  },
  methods: {
    get_line_class(p) {
      // if (Math.abs(p) < 1) {
      //   return ''
      // }
      // charge
      if (p > 0) {
        return 'down'
      }
      // discharge
      if (p < 0) {
        return 'up'
      }
      return ''
    }
  }
}

</script>
